import { useState, useEffect } from 'react';

/**
 * Generic media-query hook (SSR-safe).
 * Returns `true` when the viewport matches the given CSS media query string.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/**
 * Convenience: returns `true` when viewport width ≥ 768px.
 */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 768px)');
}
